export type TPatientNameParts = {
  title?: string | null;
  initials?: string | null;
  first_name?: string | null;
  middle_name?: string | null;
  last_name?: string | null;
};

export type TFormatPatientNameOptions = {
  title?: string | null;
  preferInitials?: boolean;
};

export function formatPatientName(
  patient: TPatientNameParts | null | undefined,
  options: TFormatPatientNameOptions = {}
): string {
  if (!patient) {
    return '';
  }

  const givenName = options.preferInitials
    ? patient.initials || patient.first_name
    : patient.first_name || patient.initials;

  return [options.title, givenName, patient.middle_name, patient.last_name].filter((part) => !!part).join(' ');
}
